<script setup lang="ts">
import {features} from '@/static/features';
import type {FeatureItemData} from '~/types';

const featureItems = ref<FeatureItemData[] | null>(features);

const slideCount = ref(0);
const previousCount = ref(features.length - 1);

onMounted((): void => {
  const slideId = featureItems.value![0].id;
  const {sendScreenView} = useAnalytics();
  sendScreenView({
    type: 'FeatureSlider.SlideView',
    target: slideId,
  });
});
</script>

<template>
  <div class="feature-block">
    <div class="container">
      <FeatureItem
        v-for="(item, index) in featureItems"
        :id="index"
        :key="index"
        ref="`feature${index}`"
        :class="{
          active: slideCount == index,
          'active-out': previousCount == index,
        }"
        :data="item"
        :index="index + 1"
        :is-active="slideCount == index" />
    </div>
  </div>
</template>

<style lang="scss">
.feature-block {
  overflow: hidden;
  position: relative;
  width: 100%;

  .container {
    aspect-ratio: 16 / 9;
    margin: 89px auto 0 auto;
    max-width: var(--project-feature-max-width, 1920px);
    overflow: hidden;
    position: relative;
    width: 100%;

    @media only screen and (max-width: 940px) {
      margin-top: 63px;
    }

    @media only screen and (max-width: 1024px) and (orientation: portrait) {
      aspect-ratio: auto;
      height: calc(100svh - 89px - 7.5rem);
    }

    @media only screen and (max-width: 940px) and (orientation: portrait) {
      height: calc(100svh - 63px - 7.5rem);
    }

    @media only screen and (max-width: 768px) and (orientation: landscape) {
      aspect-ratio: auto;
      height: calc(100svh - 63px - 7.5rem);
    }
  }
}
</style>
